export default __webpack_public_path__ + "alberta-next-visit-field.ee9ebdd3be68c4cb5245.svg";